import * as React from "react";
import { SVGProps } from "react";
const SvgBackground = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 64 64" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.357 2.058c-4.21.801-7.498 4.09-8.299 8.299-2.744 14.429-2.744 28.857 0 43.286.801 4.21 4.09 7.498 8.299 8.298A115.6 115.6 0 0 0 32 64a115.6 115.6 0 0 0 21.643-2.059c4.21-.8 7.498-4.088 8.299-8.298 2.744-14.429 2.744-28.857 0-43.286a10.427 10.427 0 0 0-8.299-8.299A115.574 115.574 0 0 0 32 0c-7.214 0-14.429.686-21.643 2.058Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBackground;
